import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/` is now a doorway, not a screen.
 *
 * Home lives at `/home`, which gives it a name a founder can type, bookmark
 * and be sent. The root still has to answer, though: it is where Google's
 * callback lands, where `safeRedirect` falls back to, and what every bookmark
 * made before this change points at. So it redirects rather than 404s.
 *
 * `replace` so the root never lands in history — a back gesture from Home
 * should leave, not bounce through `/` and forward again.
 */
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/home", replace: true });
  },
});
